import { Config } from './config.type'
const config: Config  = {
    "build": {
        "host": "https://graphql0.canvasflow.io",
        "subdirectory": "/",
        "website": "",
        "assetDirectory": "/",
        "title": "The Daily Enquirer",
        "shortTitle": "Daily Enquirer",
        "appKey": "e697a8f2-729a-40f2-a086-7d3f0708db4e",
        "language": "en",
        "languages": [
            "en"
        ],
        "about": "<p style=\"padding: 2px;\"><a href=\"https://nationalenquirer.com/cookie-policy/\" target=\"_blank\" rel=\"noreferrer\">Cookie Policy</a></p><p style=\"padding: 2px;\"><a href=\"https://nationalenquirer.com/privacy-policy/\" target=\"_blank\" rel=\"noreferrer\">Privacy Policy</a></p><p style=\"padding: 2px;\"><a href=\"https://nationalenquirer.com/california-privacy-policy/\" target=\"_blank\" rel=\"noreferrer\">California Privacy Policy</a></p><p style=\"padding: 2px;\"><a href=\"https://nationalenquirer.com/ad-choices/\" target=\"_blank\" rel=\"noreferrer\">Ad Choices</a></p><p style=\"margin-top: 10px; line-height:1.3;\">The Daily Enquirer is part of MediaCo. <br/> © 2026 MediaCo LLC.<br/> All Rights Reserved.</p>",
        "buildNumber": 934032,
        "buildDate": "2026-03-17T13:33:33.266Z",
        "version": "2.11.1"
    },
    "app": {
        "contentProtection": false,
        "admin": true,
        "favorite": false,
        "auth": {
            "enabled": true,
            "type": "cognito",
            "config": {
                "host": "https://auth.thedailyenquirer.com",
                "clientId": "5jn2d700ip68e6h8ion3mq8mdr",
                "customerPortalUrl": "https://billing.stripe.com/p/login/cNi5kweYU0viamIgG60co00"
            }
        },
        "hideNavbarOnScroll": false,
        "installationOption": {
            "enabled": false
        },
        "password": {
            "enabled": false,
            "value": ""
        },
        "template": {
            "type": "daily"
        },
        "legal": {
            "tou": {
                "url": "",
                "label": ""
            },
            "privacy": {
                "url": "",
                "label": ""
            },
            "cookie": {
                "url": "",
                "label": ""
            }
        },
        "cache": {
            "ttl": {
                "getAllIssues": 5,
                "previewIssue": 5,
                "getIssue": 5,
                "getFeatureArticles": 5,
                "styles": 5
            }
        },
        "menu": {
            "externalUrl": {
                "enabled": false,
                "url": "/",
                "title": "The Daily Enquirer"
            },
            "links": [
                {
                    "title": "National Enquirer",
                    "icon": "",
                    "url": "https://nationalenquirer.com/"
                },
                {
                    "title": "About Us",
                    "icon": "",
                    "url": "https://nationalenquirer.com/about-us/"
                },
                {
                    "title": "Editorial Policies",
                    "icon": "",
                    "url": "https://nationalenquirer.com/editorial-policies/"
                },
                {
                    "title": "Editor’s Notes",
                    "icon": "",
                    "url": "https://nationalenquirer.com/editors-notes/"
                },
                {
                    "title": "Terms and Conditions",
                    "icon": "",
                    "url": "https://nationalenquirer.com/terms-of-use/"
                },
                {
                    "title": "Customer Service",
                    "icon": "",
                    "url": "mailto:support+thedailyenquirer@smartmags.com"
                },
                {
                    "title": "Contact Us",
                    "icon": "",
                    "url": "https://nationalenquirer.com/contact-us/"
                }
            ]
        }
    },
    "issue": {
        "contentType": "responsive-replica",
        "lastLocation": {
            "enabled": false
        }
    },
    "analytics": {
        "tealium": {
            "ChannelID": "",
            "pageType": "",
            "pageDetail": "",
            "pageTemplate": "",
            "projectType": "",
            "url": ""
        },
        "google": {
            "trackerID": "",
            "sampleRate": 0
        },
        "ga4": {
            "trackerID": "",
            "sampleRate": 1
        },
        "gtm": {
            "trackerID": ""
        },
        "googleOptimize": {
            "trackerID": ""
        },
        "onetrust": {
            "id": ""
        },
        "caymland": {
            "domain": ""
        },
        "ackee": {
            "domainId": "",
            "server": ""
        },
        "netstats": {
            "trackerID": ""
        },
        "hotjar": {
            "trackerID": ""
        },
        "hubspot": {
            "trackerID": ""
        },
        "ShareThis": {
            "trackerID": ""
        },
        "cookiefirst": {
            "key": ""
        },
        "cookiehub": {
            "trackerID": ""
        },
        "plausible": {
            "domain": ""
        },
        "matomo": {
            "urlBase": "https://jj2gaz.cflowdev.com/",
            "siteId": 1,
            "trackerUrl": "https://jj2gaz.cflowdev.com/matomo.php",
            "srcUrl": "https://jj2gaz.cflowdev.com/matomo.js",
            "disabled": false,
            "heartBeat": {
                "active": true,
                "seconds": 10
            },
            "linkTracking": false,
            "configurations": {
                "disableCookies": false,
                "setSecureCookie": false,
                "setRequestMethod": "POST"
            }
        }
    }
};
export default config;